import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  onlineUserStatus: false,
  showToaster: false,
  pendingUsersList: [],
  accpetedUsersList: [],
  onlineUsersList: [],
  toastMessage: null,
  typingUsersList: [],
  messagesList: [],
  latestConversationsList: [],
  unseenMessages: [],
  unReadCount: 0,
  messagesTime:[],


};

const chatSlice = createSlice({
  name: "Chat",
  initialState,
  reducers: {
    setOnlineUserStatus: (state, action) => {
      state.onlineUserStatus = action.payload;
    },
    setShowToaster: (state, action) => {
      state.showToaster = action.payload;
    },
    setPendingUsersList: (state, { payload }) => {
      state.pendingUsersList = payload;
    },
    setAccpetedUsers: (state, { payload }) => {
      state.accpetedUsersList = payload;
    },
    setOnlineUsersList: (state, { payload }) => {
      state.onlineUsersList = payload;
    },
    setToastMessage: (state, { payload }) => {
      state.toastMessage = payload;
    },
    setTypingUsersList: (state, { payload }) => {
      state.typingUsersList = payload;
    },
    setLatestConversationsList: (state, { payload }) => {
      state.latestConversationsList = payload;
    },
    setUnseenMessages: (state, { payload }) => {
      state.unseenMessages = payload;
    },
    setMessagesTime: (state, { payload }) => {
      state.messagesTime = payload;
    },
    setMessagesList: (state, { payload }) => {
      state.messagesList = payload;
    },
    setUnReadCount: (state, { payload }) => {
      state.unReadCount = payload;
    },

    resetStateChat: () => initialState,
  },
});

// Two actions generated from the slice
export const {
  setOnlineUserStatus,
  setPendingUsersList,
  setAccpetedUsers,
  setOnlineUsersList,
  setTypingUsersList,
  setLatestConversationsList,
  setUnseenMessages,
  setToastMessage,
  resetStateChat,
  setMessagesList,
  setShowToaster,
  setUnReadCount,
  setMessagesTime
} = chatSlice.actions;

// The reducer
export default chatSlice.reducer;
